import { useQuery } from "@tanstack/react-query";
import { Navigate, Route, Routes } from "react-router";
import { api, ApiError } from "./api";
import { Shell } from "./Shell";
import { AdminPage } from "./pages/Admin";
import { KeysPage } from "./pages/Keys";
import { LogsPage } from "./pages/Logs";
import { ModelsPage } from "./pages/Models";
import { ServiceKeysPage } from "./pages/ServiceKeys";
import { SetupPage } from "./pages/Setup";
import { SignInPage } from "./pages/SignIn";
import { UsagePage } from "./pages/Usage";

export function App() {
  const me = useQuery({ queryKey: ["me"], queryFn: api.me });

  if (me.isPending) return <div className="center-screen"><forge-circular-progress aria-label="Loading" /></div>;
  if (me.error instanceof ApiError && me.error.status === 401) return <SignInPage />;
  if (me.error) {
    return (
      <div className="center-screen">
        <forge-page-state>
          <forge-icon slot="graphic" name="error" />
          <div slot="title">The app could not reach its server</div>
          <p slot="message">{String(me.error.message)}</p>
        </forge-page-state>
      </div>
    );
  }

  const m = me.data;
  return (
    <Shell me={m}>
      <Routes>
        <Route path="/" element={<UsagePage />} />
        <Route path="/keys" element={<KeysPage me={m} />} />
        <Route path="/setup" element={<SetupPage me={m} />} />
        <Route path="/usage" element={<Navigate to="/" replace />} />
        <Route path="/logs" element={<LogsPage />} />
        <Route path="/models" element={<ModelsPage />} />
        {m.isAdmin && <Route path="/service-keys" element={<ServiceKeysPage me={m} />} />}
        {m.isAdmin && <Route path="/admin/*" element={<AdminPage me={m} />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
